<p-drawer [visible]="visible()" [position]="drawerPosition()" (onHide)="closeSidebar()"
  [header]="'account.alerts-panel-label' | translate" [showCloseIcon]="false"
  styleClass="p-sidebar-md" appendTo="body" [baseZIndex]="10000">
  <div class="notif-redesign">
    <div class="drawer-head cream">
      <h2 class="drawer-title">{{ 'account.alerts' | translate }}</h2>
      <div class="tools">
        <button type="button" class="drawer-tool reloadAlerts" (click)="store.refresh()"
          [disabled]="store.loading() || store.mutating()"
          [attr.aria-label]="'account.refresh-alerts-button' | translate"
          [title]="'account.refresh-alerts-button' | translate">
          <i class="pi pi-refresh" aria-hidden="true"></i>
        </button>
        @if (store.unreadCount() > 0) {
          <button type="button" class="drawer-tool markAllAlertsRead" (click)="store.markAllRead()"
            [disabled]="store.mutating()"
            [attr.aria-label]="'notifications.mark-all-read' | translate"
            [title]="'notifications.mark-all-read' | translate">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
          </button>
        }
        @if (store.items().length > 0) {
          <button type="button" class="drawer-tool clearAlerts" (click)="store.clear()"
            [disabled]="store.mutating()"
            [attr.aria-label]="'account.clear-all-alerts-button' | translate"
            [title]="'account.clear-all-alerts-button' | translate">
            <i class="pi pi-trash" aria-hidden="true"></i>
          </button>
        }
        <button type="button" class="drawer-close" (click)="closeSidebar()"
          [attr.aria-label]="'app.close' | translate">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="drawer-body" [attr.aria-busy]="store.loading() || store.mutating()">
      <p class="notifications-count" role="status">
        {{ 'app.alerts-count' | translate: { count: store.unreadCount() } }}
      </p>
      @if (store.legacyState().error) {
        <div class="notifications-feedback" role="status" data-source="legacy">
          <p>{{ 'notifications.legacy-unavailable' | translate }}</p>
          <button type="button" class="notifications-action" (click)="store.refresh('legacy')"
            [disabled]="store.legacyState().loading">
            {{ 'notifications.retry' | translate }}
          </button>
        </div>
      }
      @if (store.notifierState().error) {
        <div class="notifications-feedback" role="status" data-source="notifier">
          <p>{{ 'notifications.notifier-unavailable' | translate }}</p>
          <button type="button" class="notifications-action" (click)="store.refresh('notifier')"
            [disabled]="store.notifierState().loading">
            {{ 'notifications.retry' | translate }}
          </button>
        </div>
      }
      @if (store.operationError()) {
        <p class="notifications-feedback" role="alert">{{ 'notifications.operation-failed' | translate }}</p>
      }
      @if (store.loading()) {
        <p class="notifications-loading" role="status">{{ 'notifications.loading' | translate }}</p>
      }
      @if (store.items().length > 0) {
        <ul class="notif-list notifications-list" [attr.aria-label]="'account.alerts-list-label' | translate">
          @for (alert of store.items(); track alert.key) {
            <li class="notif" [class.newAlert]="alert.isUnread" [attr.data-notification-key]="alert.key">
              <div class="main">
                <button type="button" class="who notifications-open" (click)="goToContext(alert)"
                  [disabled]="opening() !== null || store.mutating()">
                  {{ alert.title }}
                </button>
                <div class="sub" [innerHTML]="alert.body"></div>
                <div class="notifications-meta">
                  @if (alert.isUnread) {
                    <span>{{ 'account.alert-new-status' | translate }}</span>
                  }
                  @if (alert.createdAtUtc) {
                    <time [attr.datetime]="alert.createdAtUtc">{{ alert.createdAtUtc | date: 'short' }}</time>
                  }
                </div>
              </div>
              <div class="notif-actions">
                <button type="button" class="x removeAlertIcon" (click)="store.remove(alert)"
                  [disabled]="store.mutating() || opening() !== null"
                  [attr.aria-label]="'account.dismiss-alert-button' | translate"
                  [title]="'account.dismiss-alert-button' | translate">
                  <i class="pi pi-times" aria-hidden="true"></i>
                </button>
                @if (alert.isUnread) {
                  <button type="button" class="x markAlertRead" (click)="store.markRead(alert)"
                    [disabled]="store.mutating() || opening() !== null"
                    [attr.aria-label]="'notifications.mark-read' | translate"
                    [title]="'notifications.mark-read' | translate">
                    <i class="pi pi-check" aria-hidden="true"></i>
                  </button>
                }
                <button type="button" class="chat" (click)="goToContext(alert)"
                  [disabled]="opening() !== null || store.mutating()"
                  [attr.aria-label]="'account.view-alert-details' | translate"
                  [title]="'account.view-alert-details' | translate">
                  @switch (alert.action.kind) {
                    @case ('dialog') { <i class="pi pi-comment dialogIcon" aria-hidden="true"></i> }
                    @case ('activity') { <i class="pi pi-calendar calendarIcon" aria-hidden="true"></i> }
                    @case ('project') { <i class="pi pi-server calendarIcon" aria-hidden="true"></i> }
                    @case ('news') { <i class="pi pi-megaphone" aria-hidden="true"></i> }
                    @default { <i class="pi pi-external-link" aria-hidden="true"></i> }
                  }
                </button>
              </div>
            </li>
          }
        </ul>
      } @else if (empty()) {
        <div class="notif-empty">
          <i class="pi pi-bell" aria-hidden="true"></i>
          <p class="notif-empty-text">{{ 'account.noAlerts' | translate }}</p>
        </div>
      }
      @if (store.hasMore()) {
        <button type="button" class="notifications-action notifications-more" (click)="store.loadMore()"
          [disabled]="store.notifierState().loading || store.mutating()">
          {{ 'notifications.load-more' | translate }}
        </button>
      }
    </div>
  </div>
</p-drawer>

<p-toast key="newAlert">
  <ng-template #message let-toast>
    <div class="alertMessageBody">
      <h3>{{ toast.summary }}</h3>
      <div [innerHTML]="toast.detail"></div>
      @if (toast.data) {
        <button type="button" class="notifications-action" (click)="goToContext(toast.data)"
          [disabled]="opening() !== null || store.mutating()">
          {{ 'account.view-alert-details' | translate }}
        </button>
      }
    </div>
  </ng-template>
</p-toast>
